const WORDS = [
  { t: "We", accent: false },
  { t: "Sell.", accent: true },
  { t: "You", accent: false },
  { t: "Scale.", accent: true },
];

const TICKER = [
  "Performance-based", "No upfront costs", "Face-to-face sales", "Montreal · QC",
  "Telecom & B2B", "HVAC & Energy", "We sell. You scale.",
];

export const Hero = () => (
  <header className="hero" id="top" data-testid="hero-section">
    <div className="hero-bg">
      <div className="hero-grid" />
      <div className="orb a" /><div className="orb b" />
    </div>
    <div className="container hero-content">
      <span className="eyebrow" data-testid="hero-eyebrow">The power behind the pitch</span>
      <h1 data-testid="hero-title">
        {WORDS.map((w, idx) => (
          <span key={idx} className={`word ${w.accent ? "accent" : ""}`}>
            <i style={{ animationDelay: `${0.15 + idx * 0.18}s` }}>{w.t}</i>{" "}
          </span>
        ))}
      </h1>
      <p className="hero-sub" data-testid="hero-subtitle">
        We build, deploy, and manage sales teams that convert conversations into
        revenue — without upfront costs. 100% performance-based.
      </p>
      <div className="hero-ctas">
        <a href="#qualify" className="btn" data-testid="hero-primary-cta">Schedule a Revenue Call</a>
        <a href="#services" className="btn-ghost" data-testid="hero-secondary-cta">See How We Do It →</a>
      </div>
    </div>
    <div className="hero-scroll">scroll ↓</div>
  </header>
);

export const Ticker = () => (
  <div className="ticker" data-testid="ticker">
    <div className="ticker-track">
      {[0, 1].map((n) => (
        <div key={n} style={{ display: "flex" }}>
          {TICKER.map((t, i) => <span key={i} className="ticker-item">{t}</span>)}
        </div>
      ))}
    </div>
  </div>
);
